import request from '@/utils/request'
// import qs from 'qs'

// export function getListDailyReport(query) {
//   return request({
//     url: '/report-service/v1/report/daily-report',
//     method: 'get',
//     params: query,
//     paramsSerializer: query => {
//       return qs.stringify(query, {
//         arrayFormat: 'repeat',
//         encode: false
//       })
//     }
//   })
// }

export function getTask(id, type) {
  return request({
    url: '/card-service/v1/task',
    method: 'get',
    params: {
      id,
      type
    }
  })
}

export async function checkRunningTask(id, type) {
  const res = getTask(id, type)
  if (res?.data) {
    return res?.data?.state === 'RUNNING'
  }
  return false
}
